export const standardViewSample = {
    'summary': 'Threshold Crossed: 1 datapoint [31.84234972677596 (19/12/19 17:40:00)] was greater than or equal to the threshold (90.0)',
    'event_id': '129335065553',
    'status': 'open',
    'urgency': 'high',
    'event_time': '2019-12-19T17:40:00+09:00',
    'metric_name': 'CPUUtilization',
    'threshold': '90',
    'metric_value': '93.1',
    'resource_name': 'i-9c09acd49a25',
    'event_type': 'INFO',
    'custom_details': {
        'ping time': '1500ms',
        'load avg': '0.75'
    }
};

export const standardSample = {
    'summary': 'Threshold Crossed: 1 datapoint [31.84234972677596 (19/12/19 17:40:00)] was greater than or equal to the threshold (90.0)',
    'event_id': '129335065553',
    'status': 'open',
    'urgency': 'high',
    'event_time': '2019-12-19T17:40:00+09:00',
    'metric_name': 'CPUUtilization',
    'threshold': '90',
    'metric_value': '93.1',
    'resource_name': 'i-9c09acd49a25',
    'event_type': 'INFO',
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/standard.ts